import type { ErrorBoxProps } from '@carboncopyco/ui';
import { ErrorBox } from '@carboncopyco/ui';
import { useAnalytics } from '@carboncopyco/utils';
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect } from 'react';

export interface ErrorPageProps extends ErrorBoxProps {
  error?: Error;
}

export const ErrorPage = (props: ErrorPageProps) => {
  const { title, message, error } = props;
  const { trackEvent, isAnalyticsReady } = useAnalytics();

  useEffect(() => {
    if (!isAnalyticsReady) {
      return;
    }

    trackEvent('platform.error', {
      location: 'error_page',
      error: `${title}: ${message}: ${error?.stack}`,
    });
  }, [isAnalyticsReady, trackEvent]);

  return <ErrorBox {...props} />;
};
